import { Button, message, Modal, Popover, Row, Spin } from "antd";
import styles from "./index.less";
import { ReactComponent as CopyIcon } from "@/assets/images/copy.svg";
import { OrderInfo, PayType, requestPayService } from "@/services/order";
import QrCode from "@/assets/images/qrcode.png";
import { useRequest } from "ahooks";
import { ResponseCode } from "@/constants";

type OfflinePayModalProps = {
  open: boolean;
  onClose: () => void;
  orderInfo?: OrderInfo;
  onSuccess: () => void;
};
export default function OfflinePayModal(props: OfflinePayModalProps) {
  const { open, onSuccess, onClose, orderInfo } = props;

  const handleCopy = () => {
    const copyText = `请您将款项 ￥${orderInfo?.amount} 通过银行卡转账至以下账户，并在转账过程中务必注明订单号：${orderInfo?.orderId}\n公司名称： 广州雀鲷智能科技有限公司\n开户银行： 中国工商银行股份有限公司广州广州大道支行\n银行账号： 3602072209201348114`;
    navigator.clipboard.writeText(copyText).then(() => {
      message.success("转账信息已复制到剪贴板");
    });
  };

  const { loading } = useRequest(
    async () => {
      const rsp = await requestPayService({
        orderId: orderInfo?.orderId || "",
        payType: PayType.OFFLINE,
      });
      if (rsp.code !== ResponseCode.Success) {
        message.error(rsp.msg);
      }
      return rsp.data;
    },
    { ready: open && !!orderInfo, refreshDeps: [open] }
  );

  return (
    <Modal
      width={480}
      open={open}
      title="线下汇款"
      footer={
        <div className="mt-[24px] mb-[20px] flex flex-row justify-center items-center">
          <Button
            type="primary"
            className="h-[36px] w-[200px]"
            onClick={onSuccess}
          >
            我知道了
          </Button>
        </div>
      }
      maskClosable={false}
      onCancel={onClose}
    >
      <div className={styles.card}>
        <div className={"text-text-regular text-sm font-bold mb-4"}>
          请您将款项
          <span className="text-primary-600 font-[DIN] mx-1">
            ￥{orderInfo?.amount}
          </span>
          通过银行卡转账至以下账户，并在转账过程中务必注明订单号：
          {orderInfo?.orderId}
        </div>
        <div className="text-text-regular text-sm leading-[26px]">
          公司名称： 广州十二速率智能科技有限公司
        </div>
        <div className="text-text-regular text-sm leading-[26px]">
          开户银行： 中国工商银行股份有限公司广州广州大道支行
        </div>
        <Spin spinning={loading}>
          <div className="text-text-regular text-sm leading-[26px]">
            银行账号： <span>3602072209201348114</span>
          </div>
        </Spin>
        <Row justify={"end"}>
          <Button
            icon={<CopyIcon style={{ color: "#8E5F40" }} />}
            type="default"
            onClick={handleCopy}
          >
            复制转账信息
          </Button>
        </Row>
      </div>
      <div className="mb-2 text-text-regular text-sm">
        转账成功后，财务部门将在1个工作日内完成审批流程，审批通过将立即为您开通服务。
      </div>
      <div className="text-sm mb-2 text-text-secondary">
        如遇任何问题，请随时
        <Popover
          rootClassName={styles.popover}
          trigger={"click"}
          title={
            <div className="flex flex-col justify-center items-center">
              <div className="text-black">扫码咨询客服</div>
              <img src={QrCode} width={134} className="" />
            </div>
          }
        >
          <a>联系客服</a>
        </Popover>
        。
      </div>
    </Modal>
  );
}
